import * as React from "react";
const SvgChevronRight20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 6,
        height: 11,
        fill: "black",
        viewBox: "0 0 6 11"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5.562 5.5 0 10.135V.865L5.562 5.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgChevronRight20Px;
